package com.milta.core.localization.translations.es

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nueva entrega",
    manualDeliverySubtitle = "Añade una entrega a la ruta",
    recipientNameLabel = "Nombre del destinatario",
    addressLabel = "Dirección",
    phoneNumberLabel = "Teléfono",
    deliveryTimeLimitLabel = "Hora límite",
    optionalSuffix = "(opcional)",
    submitButton = "Añadir y continuar",
    saveEditedDeliveryButton = "Guardar cambios",
    deliveryCreated = "Entrega añadida",
    errorRecipientNameRequired = "El nombre del destinatario es obligatorio",
    errorRecipientNameTooLong = "El nombre es demasiado largo (máx. 150 caracteres)",
    errorAddressRequired = "La dirección es obligatoria",
    errorAddressTooLong = "La dirección es demasiado larga (máx. 255 caracteres)",
    errorPhoneTooLong = "El teléfono es demasiado largo (máx. 20 caracteres)",
    errorDuplicateDelivery = "Esta entrega ya está en la lista (mismo destinatario y dirección)",
    errorRouteNotFound = "Ruta no encontrada",
    errorForbidden = "No tienes permiso para editar esta ruta",
    errorValidation = "Por favor, revisa los campos introducidos",
    errorGeneric = "Algo salió mal. Inténtalo de nuevo.",
    errorRouteNotInProgress = "Esta ruta ya no está en curso. No se puede añadir una entrega.",
    unknownRecipientLabel = "Desconocido",
    driverHomeTitle = "Mi ruta",
    driverModeBadge = "Modo repartidor",
    routeStatusScheduled = "Programada",
    routeStatusInProgress = "En curso",
    routeStatusCompleted = "Completada",
    routeStatusPartial = "Parcial",
    driversDepartedOne = "iniciado",
    driversDepartedMany = "iniciados",
    driversFinishedOne = "terminado",
    driversFinishedMany = "terminados",
    stopsDeliveredLabel = "Entregados",
    stopsInProgressLabel = "En curso",
    stopsTodoLabel = "Por hacer",
    stopsFailedLabel = "Fallidos",
    stopsUntreatedLabel = "Sin tratar",
    stopsCountLabel = "paradas",
    startRouteButton = "Iniciar ruta",
    noRouteTitle = "Sin ruta",
    noRouteSubtitle = "No tienes ninguna ruta asignada por ahora.",
    noRoutePastSubtitle = "No se te asignó ninguna ruta para esta fecha.",
    routeInProgressTitle = "Ruta en curso",
    routeCompletedTitle = "Ruta completada",
    addStopButton = "Añadir una parada",
    errorConflict = "La ruta ya se ha iniciado o completado.",
    greetingPrefix = "Hola",
    routeOfTheDayLabel = "RUTA DEL DÍA",
    noOtherRouteLabel = "No hay otra ruta planificada",
    routeLabel = "Ruta",
    importMenuTitle = "Importar entregas",
    importMenuSubtitle = "Varios modos combinables — elige una fuente",
    importModeScanDocumentTitle = "Escanear un documento",
    importModeScanDocumentDesc = "Fotografía una lista o una etiqueta de paquete",
    importModePdfTitle = "Importar un PDF",
    importModePdfDesc = "Albaranes de entrega, archivo escaneado",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Tu propio formato — columnas detectadas automáticamente",
    importModeManualTitle = "Entrada manual",
    importModeManualDesc = "Nombre, dirección, teléfono, hora límite",
    photoSourceSheetTitle = "¿Cómo deseas añadir la foto?",
    photoSourceTakePhoto = "Tomar una foto",
    photoSourceChooseGallery = "Elegir de la galería",
    photoSourceChooseFiles = "Elegir una imagen de archivos",
    createRouteTitle = "Crear una ruta",
    routeCardDetailLabel = "Detalle",
    importReviewTitle = "Revisar las entregas importadas",
    importReviewMissingGpsWarning = "Faltan las coordenadas GPS",
    importReviewRetryGeocodeAction = "Reintentar la geocodificación",
    createRouteEmptyDrivers = "Aún no hay conductores en tu equipo",
    editDeliveriesAction = "Editar",
    moreDeliveriesLabel = "más",
    addDeliveriesAction = "Añadir entregas",
    manualEntryAddedConfirmPrefix = "Entrega añadida:",
    manualEntryMergedConfirmPrefix = "Paquete añadido a la entrega existente",
    manualEntryAddedCountLabel = "Entregas añadidas",
    manualEntryFinishButton = "Terminar",
    optimizeRouteButton = "Optimizar la ruta",
    createRouteButtonNoOptimize = "Crear la ruta",
    errorNoEnterprise = "Ninguna empresa vinculada a tu cuenta",
    errorDriverNotFound = "Conductor no encontrado",
    errorNoDeliveries = "Añade al menos una entrega antes de optimizar la ruta",
    errorOptimizationUnavailable = "El servicio de optimización no está disponible temporalmente.",
    errorGeocodingFailed = "No se pudieron localizar algunas direcciones de entrega. Edita la dirección e inténtalo de nuevo.",
    dispatchTitle = "Optimización",
    optimizedSuccessTitle = "¡Ruta optimizada!",
    optimizedSuccessSubtitleSuffix = "paradas ordenadas para la ruta más corta",
    stopsStatLabel = "Paradas",
    stopDetailTitlePrefix = "Parada",
    stopStatusCurrentLabel = "En curso",
    stopStatusUpcomingLabel = "Próxima",
    stopStatusDeliveredLabel = "Entregado",
    stopStatusFailedLabel = "Fallido",
    stopRecipientLabel = "Destinatario",
    callActionLabel = "Llamar",
    noPhoneLabel = "Teléfono no indicado",
    packagesCountLabel = "paquetes",
    navigateButton = "Navegar",
    navigationUnavailableUnverifiedAddress = "Dirección no verificada: navegación no disponible para esta parada.",
    deadlineBeforePrefix = "Antes de",
    deadlinePastSuffix = "vencido",
    validateStopAction = "Validar esta parada",
    teamDashboardTitle = "Rutas",
    todayDateLabel = "Hoy",
    statRoutesLabel = "Rutas",
    statDeliveriesLabel = "Entregas",
    statCompletedLabel = "Completadas",
    teamSectionTitle = "Equipo",
    routeStartedAtPrefix = "Iniciada a las",
    routeCompletedAtPrefix = "Completada a las",
    routeNotStartedLabel = "Sin iniciar",
    emptyTeamRoutesTitle = "Sin rutas ese día",
    emptyTeamRoutesSubtitle = "Ningún conductor del equipo tiene una ruta planificada para esta fecha.",
    errorInvalidDate = "Fecha no válida",
    routeDetailTitle = "Detalle de la ruta",
    driverEyebrowLabel = "Conductor",
    failedDeliveryTag = "Entrega fallida",
    driverLoadingCheckTitle = "Verificación de la carga",
    loadingCheckInstructionText = "Comprueba que todos los paquetes previstos estén cargados en el vehículo antes de salir.",
    expectedPackagesLabel = "paquetes previstos para esta ruta",
    confirmLoadCheckboxPrefix = "He cargado los",
    confirmLoadCheckboxSuffix = "paquetes previstos para esta ruta",
    reportDiscrepancyToggleLabel = "Notificar una discrepancia",
    discrepancyNotePlaceholder = "Ej.: cargué 9 paquetes en lugar de 11…",
    discrepancyNoteTooLong = "Nota demasiado larga — máximo 500 caracteres.",
    undeliveredStopsSectionTitle = "Paquetes no recogidos — quitar de la ruta",
    removedStopNoticePrefix = "«",
    removedStopNoticeMiddle = "» eliminado de la ruta — 1 parada menos",
    remainingStopsSuffix = "restantes",
    confirmAndStartButton = "Confirmar e iniciar la ruta",
    loadingOnBehalfOfLabel = "Por cuenta de",
    loadingExpectedLabel = "Carga prevista",
    loadingQuestionTitle = "¿Ha cargado todos los paquetes?",
    loadingAllLoadedPrefix = "Sí, los",
    loadingAllLoadedSuffix = "paquetes están a bordo",
    loadingIncompleteOption = "Carga incompleta",
    loadingIncompleteHint = "Retiro las paradas afectadas o lo justifico",
    loadingIncompleteRemoveLabel = "Y/o retire las paradas no cargadas",
    slideToStartLabel = "Deslice para empezar",
    completeRouteButton = "Terminar la ruta",
    completeRouteDialogTitle = "¿Terminar la ruta?",
    completeRouteDialogPendingCountSuffix = "entregas aún no se han procesado",
    completeRouteDialogPendingNote = "Se marcarán como fallidas con el motivo indicado a continuación. Usted es responsable de estas entregas no tratadas.",
    completeRouteDialogBody = "Esta acción es definitiva: la ruta pasará al estado «Completada» y ya no podrá modificarse.",
    completeRouteDialogBodyAllTreated = "Todas las entregas han sido procesadas. La ruta pasará al estado «Completada» y ya no podrá modificarse.",
    completeRouteDialogConfirm = "Terminar",
    completeRouteDialogReasonLabel = "Motivo (opcional)",
    completeRouteDialogReasonPlaceholder = "Explica por qué no se trataron estas entregas…",
    completeRouteDialogNoReasonWarning = "Si no indicas un motivo, las paradas restantes se registrarán como no entregadas, por culpa del transportista.",
    routeCompletedMessage = "Ruta completada.",
    stopStatusUntreatedLabel = "No tratada",
    errorCompleteRouteStatusConflict = "Esta ruta no se puede terminar en su estado actual.",
    errorCompleteRoutePendingStopsConflict = "Todavía hay entregas pendientes. Confirma para terminar de todos modos.",
    stopSearchOpenAction = "Buscar una parada",
    stopSearchCloseAction = "Cerrar la búsqueda",
    stopSearchPlaceholder = "Nombre, dirección o teléfono",
    stopSearchClearTextAction = "Borrar el texto",
    stopSearchResultCount = "%1 paradas de %2",
    stopSearchResultCountOne = "1 parada de %1",
    stopSearchEmptyTitle = "Ninguna parada coincide",
    stopSearchEmptyHint = "Revisa la ortografía o busca por dirección o por teléfono.",
    stopSearchClearAction = "Borrar la búsqueda",
    stopPositionLabel = "n.º %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Número de paquetes",
    reoptimizeSuccessTitle = "Ruta reoptimizada",
    backToRouteButton = "Volver a la ruta",
    routeBatchMultiDriverLink = "Repartir entre varios conductores",
    routeBatchSelectTitle = "Repartir la ruta",
    routeBatchDeliveriesReadyLabel = "entregas listas para repartir",
    routeBatchDriversSectionTitle = "Conductores",
    routeBatchDriversSelectedSuffix = "conductores seleccionados",
    routeBatchOptimizeToggleTitle = "Optimizar el itinerario",
    routeBatchOptimizeToggleHelp = "RoutaR reparte y ordena las paradas según la distancia. Desactivado: reparto equitativo simple por número de paradas, sin cálculo de ruta.",
    routeBatchSubmitButtonPrefix = "Repartir entre",
    routeBatchDriversWord = "conductores",
    routeBatchOptimizationUnavailable = "Servicio de optimización temporalmente no disponible. La ruta no se creó — comprueba tu conexión y vuelve a intentarlo, o desactiva «Optimizar el itinerario» para un reparto simple inmediato.",
    routeBatchPreviewTitle = "Vista previa del reparto",
    routeBatchPreviewEyebrowMiddle = "entregas repartidas entre",
    routeBatchPreviewEyebrowSuffix = "conductores",
    routeBatchStopsChipSuffix = "paradas",
    routeBatchDistanceLabel = "Distancia",
    routeBatchDurationLabel = "Duración estimada",
    routeBatchDistanceNotCalculated = "No calculada",
    routeBatchOptimizeDisabledBanner = "Optimización desactivada: reparto equitativo por número de paradas, sin cálculo de distancia ni de orden.",
    routeBatchReoptimizeButton = "Reoptimizar",
    routeBatchDispatchButton = "Confirmar y enviar",
    errorRouteBatchAlreadyDispatched = "Este lote ya se ha enviado a los conductores — ya no se puede modificar.",
    routeBatchDispatchedTitle = "¡Rutas enviadas!",
    routeBatchDispatchedSubtitleSuffix = "conductores notificados simultáneamente, cada uno con su propia ruta programada.",
    routeBatchStatRoutesLabel = "Rutas",
    routeBatchStatDeliveriesLabel = "Entregas",
    routeBatchStatusLabel = "Estado",
    routeBatchStatusDispatchedValue = "Enviada",
    routeBatchSentAtLabel = "Enviado el",
    routeBatchPerDriverTitle = "Detalle por conductor",
    routeBatchDriverScheduledStatus = "Programada",
    routeBatchBackToHomeButton = "Volver al inicio",
    errorTooManyDrivers = "No puedes seleccionar más de 50 conductores a la vez.",
    errorTooManyDeliveries = "Un lote no puede superar las 500 entregas.",
    createRouteFabLabel = "Nueva ruta",
    createOwnRouteButtonLabel = "Crear / optimizar mi ruta",
    createOwnRouteTitle = "Crear mi ruta",
    createOwnRouteDeliveriesCountSuffix = "entregas listas",
    stopStatusEnRouteLabel = "En camino",
    yesterdayDateLabel = "Ayer",
    periodPastLabel = "Pasadas",
    periodTomorrowLabel = "Mañana",
    viewRouteButton = "Ver la ruta",
    viewButton = "Ver",
    noRouteTomorrowTitle = "Nada previsto para mañana",
    noRouteTomorrowSubtitle = "Planifica una ruta con antelación para tenerla lista mañana a primera hora.",
    planRouteButtonLabel = "Planificar una ruta",
    myRoutesTodayTitle = "Tus rutas de hoy",
    myRoutesTitle = "Tus rutas",
    weekdayShortNames = listOf("Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"),
    weekdayFullNames = listOf("Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"),
    monthNames = listOf("enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"),
    statRoutesTodayLabel = "Rutas hoy",
    statStopsTodayLabel = "Paradas hoy",
    statOnTimeLabel = "A tiempo hoy",
    statAvgProgressLabel = "Progreso medio",
    inProgressSectionTitle = "En curso",
    upcomingSectionTitle = "Próximas",
    doneSectionTitle = "Completadas",
    seeAllLabel = "Ver todo",
    continueRouteButton = "Continuar ruta",
    detailsLinkLabel = "Detalles",
    deliveryProofTitle = "Validar la entrega",
    deliveryProofStatusSectionLabel = "Estado de la entrega",
    deliveryProofPhotoSectionLabel = "Foto justificativa",
    deliveryProofPhotoHint = "Obligatoria para validar",
    deliveryProofTakePhotoCta = "Tomar una foto",
    deliveryProofRetakePhotoCta = "Volver a tomar una foto",
    deliveryProofRetakeChipLabel = "Repetir",
    deliveryProofCommentSectionLabel = "Comentario",
    failureReasonRouteClosedByDriver = "Ruta cerrada por el conductor: parada no entregada, por culpa del transportista.",
    deliveryProofCommentRequiredSuffix = "obligatorio si falla",
    deliveryProofCommentPlaceholderOptional = "Opcional — detalles sobre la entrega…",
    deliveryProofCommentPlaceholderRequired = "Explica el motivo del fallo…",
    deliveryProofCommentRequiredError = "Se requiere un comentario en caso de entrega fallida",
    deliveryProofSubmitButton = "Validar la entrega",
    deliveryProofErrorInvalidPhoto = "Foto ilegible o formato no compatible. Vuelve a tomar la foto e inténtalo de nuevo.",
    deliveryProofAlreadyProcessedBanner = "Esta parada ya ha sido procesada y ya no se puede modificar.",
    proofPhotoViewerDownloadLabel = "Descargar",
    proofPhotoViewerCloseLabel = "Cerrar",
    proofPhotoDownloadedMessage = "Foto guardada en la galería.",
    proofPhotoDownloadErrorMessage = "No se pudo guardar la foto.",
    deliveryConfirmTitle = "Entrega validada",
    deliveryConfirmSuccessTitle = "Entrega confirmada",
    deliveryConfirmSuccessSubtitle = "La prueba se ha guardado para esta parada.",
    deliveryConfirmFailedTitle = "Fallo registrado",
    deliveryConfirmFailedSubtitle = "El comentario y la foto se han enviado al gestor.",
    deliveryConfirmRouteCompletedTitle = "¡Ruta completada!",
    deliveryConfirmRouteCompletedSubtitle = "Todas las paradas han sido procesadas.",
    deliveryConfirmValidatedAtLabel = "Validado el",
    deliveryConfirmNextStopEyebrowPrefix = "Siguiente parada",
    deliveryConfirmGoToNextStopButton = "Ir a la siguiente parada",
    deliveryConfirmAllDoneMessage = "Esta era la última parada de la ruta — recuerda cerrarla.",
    offlineBannerTitle = "Sin conexión",
    offlineBannerRouteSubtitle = "tus validaciones se enviarán en cuanto vuelva la red",
    offlineBannerValidateSubtitle = "se guardará localmente",
    offlineSyncingBannerTitle = "Sincronización en curso",
    offlineSyncingSubtitleSuffix = "entregas enviadas",
    offlineRetryBannerTitle = "Sincronización fallida",
    offlineRetryBannerSubtitle = "nuevo intento en la próxima conexión de red",
    offlineSyncSuccessToastSuffix = "entregas sincronizadas con éxito",
    offlineQueuedBadgePendingLabel = "Pendiente de envío",
    offlineQueuedBadgeSyncingLabel = "Enviando",
    offlineQueuedBadgeFailedLabel = "Fallido — nuevo intento previsto",
    offlineQueuedBadgeConflictLabel = "Ya gestionado en otro lugar",
    offlineDismissConflictAction = "Descartar",
    offlineValidatedLocallyAtPrefix = "validado localmente a las",
    offlineAddStopRequiresConnectionSuffix = "(requiere conexión)",
    deliveryProofOfflineSubmitButton = "Guardar (sincronización diferida)",
    deliveryProofSavedLocallyTitle = "Guardado localmente",
    deliveryProofSavedLocallySubtitle = "Esta entrega se enviará automáticamente en cuanto se restablezca la conexión.",
    routeScheduledBannerTitle = "Ruta aún no iniciada",
    routeScheduledBannerSubtitle = "Inicia la ruta para poder validar una entrega.",
    geocodeIssueTag = "Dirección no localizada",
    regeocodeAction = "Reintentar geolocalización",
    regeocodeSuccessMessage = "Direcciones actualizadas",
    dashboardTitle = "Dashboard",
    viewAllAction = "Ver todo",
    deleteRouteDialogTitle = "¿Eliminar la ruta?",
    deleteRouteDialogMessage = "Esta ruta se eliminará de forma permanente. Esta acción no se puede deshacer.",
    errorRouteDeleteConflict = "Eliminación no disponible: la ruta está en curso.",
    errorDriverHasActiveRoute = "Ya hay otra ruta en curso. Finalícela antes de iniciar esta.",
    routeBatchNoStopsTag = "Sin paradas",
    routeBatchNoStopsDialogTitle = "Conductor sin paradas",
    routeBatchNoStopsDialogMessage = "Al menos un conductor no tiene ninguna parada asignada. Aun así recibirá una ruta vacía si no se elimina de este lote. ¿Enviar de todos modos?",
    routeBatchAddressesToReviewTag = "dirección(es) por verificar",
    otherDeliveriesInImportLabel = "Otras entregas de esta importación",
    proofPhotoUnavailableLabel = "Foto no disponible",
    deliveryProofPhotoOptionalSectionLabel = "Foto (opcional)",
    proofWithoutPhotoLabel = "Sin foto",
    removeStopDialogTitle = "¿Eliminar esta parada?",
    removeStopDialogMessage = "«{name}» ({count} paquetes) se eliminará de la ruta. Esta acción es irreversible.",
    deliveryRemovedMessage = "Entrega eliminada",
    undoAction = "Deshacer",
    callLaunchFailed = "No se puede iniciar la llamada en este dispositivo",
    keepDraftsDialogTitleOne = "¿Conservar la entrega?",
    keepDraftsDialogTitleMany = "¿Conservar las {count} entregas?",
    keepDraftsDialogMessage = "Las ha introducido, pero todavía no están en la lista.",
    keepDraftsAction = "Conservar",
    deliveriesAddedToRouteOne = "1 entrega añadida a la ruta",
    deliveriesAddedToRouteMany = "{count} entregas añadidas a la ruta",
    driverJoinedTeamMessage = "{name} se ha unido al equipo",
    ownRouteCreatedNotOptimizedMessage = "Ruta creada en el orden introducido: no se pudo realizar la optimización",
    draftExitTitle = "¿Salir de la creación?",
    draftExitMessageOne = "Ha añadido 1 entrega ({packages} paquetes).",
    draftExitMessageMany = "Ha añadido {count} entregas ({packages} paquetes).",
    draftKeepAction = "Guardar para más tarde",
    draftDeleteDeliveriesAction = "Eliminar las entregas",
    draftContinueAction = "Continuar la creación",
    draftSavedMessage = "Borrador guardado",
    draftCardTitle = "Ruta en creación",
    draftForDate = "para el {date}",
    draftResumeAction = "Reanudar",
    draftDeleteDialogTitle = "¿Eliminar el borrador?",
    draftDeleteDialogMessageOne = "La entrega ({packages} paquetes) ya introducida se eliminará. Esta acción es irreversible.",
    draftDeleteDialogMessageMany = "Las {count} entregas ({packages} paquetes) ya introducidas se eliminarán. Esta acción es irreversible.",
    draftResumeImportTitle = "Reanudar la ruta en curso",
    draftImportAddsHint = "Las entregas importadas se añadirán a este borrador:",
    stopDeliveredAtPrefix = "Entregado a las",
    stopFailedAtPrefix = "Fallido a las",
    stopOnTimeLabel = "A tiempo",
    stopLateByPrefix = "Con retraso de",
    stopTimeLabel = "Tiempo",
    stopAfterStartSuffix = "después de la salida",
    stopAfterPreviousSuffix = "después de la parada anterior",
    stopDriverCommentLabel = "Comentario del conductor",
    stopPackagesLabel = "Paquetes",
    durationHoursUnit = "h",
    durationMinutesUnit = "min",
    ),
)
